import type {GlobalState} from 'types/store';

export const getSelectedThreadId = (state: GlobalState) => state.userThreads.selectedThreadId;
